import { Injectable } from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';
import {FindHttpError} from '../error/find-http-error';
import {AutoEletricProvidedService} from '../model/auto-eletric-provided-service';
import {HttpError} from '../error/http-error';
import {HttpService} from './http.service';

@Injectable()
export class AutoEletricProvidedServiceService {
  private static AUTO_ELETRIC_SERVICE_ENDPOINT = '/autoEletricService';

  private FIND_LIST_BY_AUTO_ELETRIC = `${AutoEletricProvidedServiceService.AUTO_ELETRIC_SERVICE_ENDPOINT}/findListByAutoEletricId/`;

  find$: Observable<Array<AutoEletricProvidedService>>;
  error$: Observable<HttpError>;

  private findSubject: Subject<Array<AutoEletricProvidedService>>;
  private errorSubject: Subject<HttpError>;

  constructor(private _httpService: HttpService) {
    this.findSubject = new Subject();
    this.find$ = this.findSubject.asObservable();
    this.errorSubject = new Subject();
    this.error$ = this.errorSubject.asObservable();
  }

  findListByAutoEletricId(autoEletricId: number) {
    this._httpService.get(`${this.FIND_LIST_BY_AUTO_ELETRIC}${autoEletricId}`, Array, FindHttpError)
      .subscribe(
        autoEletricServices => this.findSubject.next(autoEletricServices),
        error => this.errorSubject.next(error)
      );
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/service/auto-eletric-provided-service.service.ts